import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp, getApp } from 'firebase/app';  
import firebaseConfig from '../firebaseConfig';
import environment from '../environments/index';

let app;
let analytics;

try {
  app = getApp();
  analytics = getAnalytics(app); 
} catch (error) {
  app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app); 
}

export { app, analytics };

export const fireAnalytics = (eventName, eventParams) => {
  try {
    logEvent(analytics, eventName, eventParams);
    if (!environment.isProduction) {
      console.log('📊 Analytics Event:', eventName, eventParams);
    }
  } catch (error) {
    if (!environment.isProduction) {
      console.error('❌ Error al enviar evento de Analytics:', error);
    }
  }
};
